import {
  TennisResultsCategories,
  TennisResultsCategoriesProps,
} from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";

import { transformQuery } from "./transformers/transformQuery";
import { ResultsCategoriesData } from "./types";
import { useEffect, useRef, useState } from "react";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<ResultsCategoriesData>) => {
  return {
    "data-tennis-results-categories-wrapper": true,
    variables: JSON.stringify(variables),
  };
};

export function getServerProps({
  props,
}: WidgetContext<ResultsCategoriesData>): TennisResultsCategoriesProps {
  return transformQuery(props);
}

const isClient = (force?: boolean | undefined): boolean =>
  typeof force === 'boolean' ? force : typeof window !== 'undefined';

const localStorageKey = isClient() ? `${window.location.pathname}_activeIndex` : 'activeIndex';

const getInitialIndex = () => {
  if (!isClient()) {
    return 0;
  }
  return parseInt(window?.localStorage?.getItem(localStorageKey) || '0', 10) as number;
};

const setManualScrollRestoration = () => {
  
  history.scrollRestoration = 'manual';
  
}

export default function ResultsCategories({
  props,
  ...rest
}: WidgetContext<TennisResultsCategoriesProps>) {
  log({ props, ...rest });

  const firstChange = useRef(true);
  const [activeIndex, setActiveIndex] = useState(getInitialIndex());

  const handleCategoryChange = () => {
    if (firstChange.current) {
      firstChange.current = false;
      return;
    }

    const $container = document.querySelector("ld-tennis-sdapi-results-container");
    if (!$container) return;

    const offset = 230;
    const containerRect = $container.getBoundingClientRect();

    window.scrollTo({ top: containerRect.top + window.scrollY - offset });
  };


  useEffect(() => {
    if (isClient()) {
      window.localStorage.setItem(localStorageKey, `${activeIndex}`);
      window.scrollTo({ top: 0 });
    }
  }, [activeIndex]);

  useEffect(() => {
    if ('scrollRestoration' in history) {
     setManualScrollRestoration()
    }
  }, [])

  return (
    <TennisResultsCategories
      {...props}
      initialIndex={activeIndex}
      setDefaultIndex={setActiveIndex}
      onCategoryChange={handleCategoryChange}
    />
  );
}
